
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/localita-sciistiche",
      function () {
        return require("private-next-pages/[region]/localita-sciistiche.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/localita-sciistiche"])
      });
    }
  